import { Crop } from './crop';
import { User } from './user';
import { Commodity } from './commodity';
import { Variety } from './variety';

export class Load {
  id: number;
  quantity: number;
  unit: string;
  commodity: string | Commodity;
  commodityO: Commodity;
  source: string;
  destination: string;
  user: User;
  docNumber: string;
  humidityPercent: number;
  sugarPercent: number;
  acidity: number;
  ph: number;
  mouldedPercent: number;
  note: string;
  attachmentUrl: string;
  activityDate: Date;
  fieldIds: Array<number>;
  cropIds: Array<Crop>;
  variety: Variety;
  container: number;
  inertsForeignMatters: number;
  conveyor: string;
  licensePlate: string;
  greenTomatoes: number;
  rottenTomatoes: number;
  crushedOrSplitFruit: number;
  unripeFruits: number;
  sunburn: number;
  healedLesionsOfMechanicalOrigin: number;
  overripeFruits: number;
  brixDegrees: number;
  densityRawCherries: number;
  estimateFloats: number;
  estimateCherries: number;
  estimateGreens: number;
  brix: number;
  counter?: number;
  coffeeType?: string;
  harvestingType?: string;
  crops?: Array<any>;
  checked?: boolean;
  cropYear?: number;

  constructor() {
    this.id = null;
    this.quantity = null;
    this.unit = null;
    this.commodity = null;
    this.commodityO = null;
    this.source = null;
    this.destination = null;
    this.user = null;
    this.docNumber = null;
    this.humidityPercent = null;
    this.sugarPercent = null;
    this.acidity = null;
    this.ph = null;
    this.mouldedPercent = null;
    this.note = null;
    this.attachmentUrl = null;
    this.activityDate = null;
    this.fieldIds = null;
    this.cropIds = null;
    this.variety = null;
    this.container = null;
    this.inertsForeignMatters = null;
    this.conveyor = null;
    this.licensePlate = null;
    this.greenTomatoes = null;
    this.rottenTomatoes = null;
    this.crushedOrSplitFruit = null;
    this.unripeFruits = null;
    this.sunburn = null;
    this.healedLesionsOfMechanicalOrigin = null;
    this.overripeFruits = null;
    this.brixDegrees = null;
    this.densityRawCherries = null;
    this.estimateFloats = null;
    this.estimateCherries = null;
    this.estimateGreens = null;
    this.brix = null;
    this.coffeeType = null;
    this.harvestingType = null;
    this.crops = null;
    this.checked = false;
    this.cropYear = null;
  }
}

/*
*********** MODELLO DI BACKEND **********************

package com.xfarm.api.v1.core

import com.xfarm.api.v1.auth.User
import grails.databinding.BindingFormat

class Load {
    transient springSecurityService

    Long    companyId = -1
    Double  quantity
    string  unit
    string  commodity
    string  source
    string  destination
    User    user
    string  docNumber
    Double  humidityPercent
    string  note
    string  attachmentUrl
    @BindingFormat("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
    Date    activityDate
    Date    dateCreated
    Date    lastUpdated

    List<Long> fieldIds
    Long container


    static constraints = {
        quantity        blank: false, nullable: false
        unit            blank: false, nullable: true, inList: ['bu', 'cwt', 'lb', 'ton', 'kg']
        commodity       blank: false, nullable: false
        source          blank: false, nullable: true
        destination     blank: false, nullable: false
        user            blank: false, nullable: true
        docNumber       blank: false, nullable: true
        humidityPercent blank: false, nullable: true
        note            blank: false, nullable: true
        attachmentUrl   blank: false, nullable: true, url: true
        activityDate    blank: false, nullable: false
        fieldIds        blank: false, nullable: true
        container       blank: false, nullable: true
    }

    static mapping = {
        autoTimestamp true
    }

    def beforeInsert() {
        companyId = User.get(springSecurityService?.principal?.id)?.farm?.id
    }

    def beforeUpdate() {
        if(companyId != User.get(springSecurityService?.principal?.id)?.farm?.id){
            return false
        }
    }
}

*/
